export default "__VITE_PUBLIC_ASSET__730dc731__"